let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hbucU")).then(() => parcelRequire('8Q01i'));